import { LinearProgress } from "@/components/progress";
import { SuppliesData } from "../schema/price-board.schema";
import { SuppliesPriceCard } from "./supplies/SuppliesPriceCard";
import { Box } from "@chakra-ui/react";
import { NoData } from "@/components/common/section-components/NoData";

interface Props {
  loadingPrices: boolean;
  sectionData?: SuppliesData;
}
export const SuppliesTable = ({ loadingPrices, sectionData }: Props) => {
  return loadingPrices ? (
    <LinearProgress />
  ) : (
    <>
      {!loadingPrices && Boolean(!sectionData?.insumos?.length) && (
        <Box marginTop="30px">
          <NoData />
        </Box>
      )}
      {!loadingPrices && Boolean(sectionData?.insumos?.length) && (
        <SuppliesPriceCard sectionData={sectionData} />
      )}
    </>
  );
};
